import AddFieldDropdown from './common/add-field-dropdown';
import CompanyLogo from './common/company-logo';
import AttachmentField from './common/fields/attachment-field';
import BorderTextField from './common/fields/border-text-field';
import DropdownField from './common/fields/dropdown-field';
import MultiSelectField from './common/fields/multi-select-field';
import SingleSelectField from './common/fields/single-select-field';
import VideoRecordingField from './common/fields/video-recording';
import LiveStatsDialog from './common/live-stats-dialog';

import FieldEditSection from '@/shared/components/field-edit-section/field-edit-section';

// FormEditInputSection is now FieldEditSection in shared — re-exported here for backward compatibility
const FormEditInputSection = FieldEditSection;

export {
	FormEditInputSection,
	FieldEditSection,
	CompanyLogo,
	AddFieldDropdown,
	LiveStatsDialog,
	AttachmentField,
	BorderTextField,
	DropdownField,
	MultiSelectField,
	SingleSelectField,
	VideoRecordingField,
};
